export const objectiveIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Objective Pre/Post report is where you can view results from Objective Pre and Posttests for each objective. There are six objectives in the WordFlight System.'
  },
  {
    element: '.student-dropdown-row',
    intro: 'Select a student from the dropdown to view their specific Objective Pre/Post data.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Objective Pre/Post report for the selected student.'
  },
  {
    element: '#objective-dropdown',
    intro: 'Select an objective from the dropdown. An objective will appear after a student has reached it in the WordFlight System.'
  },
  {
    element: '.objective-chart-container',
    intro: 'See the student’s Objective Pre and Posttest results for the selected objective. The graph is broken down into four categories: Decoding Words, Using Syllables, Recognizing Words (untimed), and Recognizing Words (timed). Track student progress from the Objective Pre to Posttest.'
  },
  {
    element: '.weekly-usage-table',
    intro: 'See the student’s expected weekly usage minutes goal, average weekly usage during the selected objective, and the percent of their weekly time goal they met during the selected objective.'
  },
  {
    element: '.cumulative-objective-chart-container',
    intro: 'See the student’s Objective Pre and Posttest Cumulative Performance for all of the objectives they have completed. The graph is broken down into four categories: Decoding Words, Using Syllables, Recognizing Words (untimed), and Recognizing Words (timed).'
  },
  {
    element: '#cumulativeWeeklyUsageTable',
    intro: 'See the student’s expected weekly usage minutes goal, average weekly usage across all objectives, and the percent of their weekly time goal they have met throughout their time using WordFlight.'
  }
];